'use memo'

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { AgxNotificationBox, IconTaskTypes } from '@urbanx/agx.ui-components2'
import { useSelectedCampaign } from 'hooks'
import { JSX } from 'react'
import AgreementComplianceModal from 'pages/allTasks/TaskModal/AgreementComplianceModal'
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry'
import { useTaskModalDialogState } from 'pages/allTasks/TaskModal/useTaskModalDialogState'

interface AgreementComplianceProps {
  tasks: AutopilotTaskDto[]
  badge: JSX.Element
  onCompleteSuccess: () => void
}

const AgreementCompliance = ({
  tasks,
  badge,
  onCompleteSuccess,
}: AgreementComplianceProps) => {
  const { campaign } = useSelectedCampaign()
  const modalState = useTaskModalDialogState(tasks)

  return (
    <>
      {campaign?.campaignId && (
        <AgreementComplianceModal
          tasks={modalState.modalTasks}
          isOpen={modalState.isOpen}
          onClose={modalState.close}
          onCompleteSuccess={onCompleteSuccess}
          campaignId={campaign.campaignId}
          campaign={campaign}
        />
      )}
      <TaskModalEntry
        title="Agreement Compliance"
        tasks={tasks}
        badge={badge}
        iconType={IconTaskTypes.AgreementCompliance}
        actionText="Complete Compliance Check"
        actionButtonId="completeComplianceCheckBtn"
        panelKey="AgreementCompliancePanel"
        onAction={modalState.open}
        notification={
          campaign?.flatCommissionBelowMinimumAlert ? (
            <AgxNotificationBox
              type="warning"
              heading=""
              body="Commission rate is low. Alert Admin Manager and confirm rate is correct before proceeding."
            />
          ) : undefined
        }
      />
    </>
  )
}
export default AgreementCompliance
